<template>
<b-input-group>
  <b-form-input v-model="localInputString" type="text" placeholder="Search..."></b-form-input>
  <b-input-group-append>
    <b-btn size="sm" text="Button" variant="primary" v-on:click="clearInputString"><i class="far fa-times-circle fa-lg"></i></b-btn>
  </b-input-group-append>
</b-input-group>
</template>

<script>
export default {
  name: 'FormInputWithClearButton',
  props: ['inputString'],
  computed: {
    localInputString: {
      get: function() {
        return this.inputString;
      },
      set: function(value) {
        this.$emit('update:inputString', value);
      }
    }
  },
  methods: {
    clearInputString: function() {
      this.localInputString = '';
    }
  }
};
</script>

<!-- Sidebar styles should be scoped -->
<style src="./FormInputWithClearButton.scss" lang="scss" scoped/>
